import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './Icon.styles';

const Icon = props => {
  let { value, styles: customStyles, ...rest } = props;
  return (
    <span
      className={`lnr lnr-${value} ${css(styles.base, customStyles)}`}
      {...rest}
    />
  );
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/common/icon/Icon.js